// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FV34a","container-inner":"styles_container-inner__E80TW","flat-paper":"styles_flat-paper__PLIu2"};